namespace GeniuzPOS.InitialData {
    export interface PsCustomerSurveyDtForm {
        Status: Serenity.RadioButtonEditor;
        SurveyCode: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        Choice: Serenity.StringEditor;
    }

    export class PsCustomerSurveyDtForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsCustomerSurveyDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsCustomerSurveyDtForm.init)  {
                PsCustomerSurveyDtForm.init = true;

                var s = Serenity;
                var w0 = s.RadioButtonEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(PsCustomerSurveyDtForm, [
                    'Status', w0,
                    'SurveyCode', w1,
                    'LineNo', w2,
                    'Choice', w1
                ]);
            }
        }
    }
}
